import { computed } from 'mobx';
import { IAdvertisement, IAdvertisementExt, IEntityStore, ISupplier } from '../../main/entities';
import { MgHasher } from '../../mg/MgHasher';
import { IOcResponse } from '../../services/CommSvc';
import { AbstractRepo } from './AbstractRepo';

export class AdmAdRepo extends AbstractRepo<IAdvertisementExt> implements IEntityStore<IAdvertisementExt> {
	private readonly repos: Array<IEntityStore>;

	constructor(adRepo: IEntityStore<IAdvertisement>, supplierRepo: IEntityStore<ISupplier>) {
		super('AdmAd', () => adRepo.allAsList.map(e => ({...e, supplierName: supplierRepo.byId(e.supplierId)?.name ?? ''})));
		this.repos = [adRepo, supplierRepo];
	}

	@computed get etag() {
		for (const r of this.repos) {
			if (!r.etag) return '';
		}
		return new MgHasher().addUnordered(this.repos.map(r => r.etag + ' ' + r.id)).addString(this.id).toString();
	}

	fetch(mode?: 'NORMAL' | 'DIRECT' | 'INVALIDATE') {
		return Promise.all(this.repos.map(r => r.fetch(mode)));
	}

	handleResponse(responsePromise: Promise<IOcResponse>, successMessage: string) : Promise<unknown> {
		throw new Error('Unsupported handleResponse in AdmAdRepo ' + this.id);
	}
}
